<div class="grid">
	<div class="col-12 button-container">
		<button pButton type="button" label="{{ 'button.receiving' | translate }}"
				class="button" routerLink="/receiving" (click)="hasPrinter()"
						icon="fas fa-truck-moving"></button>
	</div>
	<div class="col-12 button-container">
		<button pButton type="button" label="{{ 'button.partsMovement' | translate }}"
		class="button" routerLink="/parts-movement" icon="fas fa-people-carry"></button>
	</div>

	
	<div class="col-12 button-container">
		<button pButton type="button" label="{{ 'button.conference' | translate }}"
		class="button" routerLink="/conference" icon="fas fa-receipt"></button>
		<!--TODO verificar icon-->


	</div>
</div>
